<template>
  <div class="add-profile-wrapper">
    <h1>Podaj kod weryfikacji dwuetapowej</h1>
    <p>W zależności od ustawień konta, kod weryfykacji
      został wysłany na twój telefon bądź e-mail.</p>
    <div>
      <form>
        <label for="two-factor-code">Kod weryfikacyjny</label>
        <input
          v-model="twoFactorCode"
          id="two-factor-code"
          placeholder="Kod z SMS-a lub e-maila..."
          type="text"
          required
        >
      </form>
      <button @click.prevent="addProfile">Wyślij</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProfileTwoFactorCodeModal",
  methods: {
    addProfile() {
      this.$store.dispatch('addProfile');
      this.$store.commit('hideModal');
      this.$store.dispatch('showLoadingModal', true);
    }
  },
  computed: {
    twoFactorCode: {
      get() {
        return this.$store.getters.profileToAddInfo.twoFactorCode;
      },
      set(value) {
        this.$store.commit('updateProfileToAddTwoFactorCode', value);
      }
    }
  }
};
</script>
